// extracted by mini-css-extract-plugin
module.exports = {"button":"PopupButton_button__GY_B0","primary":"PopupButton_primary__2F6oq","secondary":"PopupButton_secondary__1deUD"};